import { defineAsyncComponent } from "vue";
import type { Component } from "vue";

// Import all Vue components from the components folder and its subfolders
const componentModules = import.meta.glob("./components/**/*.vue") as Record<
  string,
  () => Promise<{ default: Component }>
>;

// Function to load a component based on its name
export function lazyImportRoute(name: string): () => Promise<{ default: Component }> {
  const path = `./components/${name}.vue`;

  if (componentModules[path]) {
    return componentModules[path];
  } else {
    throw new Error(`Component ${name} not found`);
  }
}

export function lazyImport(component: string): Component {
  return defineAsyncComponent(lazyImportRoute(component));
}
